<template>
  <div id="codificator-builder-new-or-edit" class="wrapper-content w-100">
    <LmComponentLoading v-if="isLoading" fixed />
    <h1>{{ $t('document_types_generator') }}</h1>
    <LmForm ref="lmFormRef" id="documentTypes-header">
      <!-- <portal-target name="destination-after-title" slim/> -->
      <b-row>
        <LmTextInput
          :disabled="formData.publish"
          class="col-6 -0"
          :v="$v.formData.typeName"
          v-model="formData.typeName"
          :label="$t('document_type_name')"
          :placeholder="$t('document_type_name_placeholder')"
        />
        <LmTextInput
          :disabled="formData.publish"
          class="col-6 -0"
          :v="$v.formData.typeAlias"
          v-model="formData.typeAlias"
          :label="$t('document_type_alias')"
          :placeholder="$t('document_type_alias_placeholder')"
        />
      </b-row>
      <LmTextArea
        class="col-12 px-0"
        v-model="formData.typeDescription"
        :v="$v.formData.typeDescription"
        :label="$t('document_type_description')"
        :placeholder="$t('document_type_description_placeholder')"
      />
      <a-form-item label="Formato de documentos">
        <a-select v-model="formData.documentsFormat" size="large">
          <a-select-option value="workflow">
            Workflow de firmas
          </a-select-option>
          <a-select-option value="oneperson">
            Unipersonal
          </a-select-option>
        </a-select>
      </a-form-item>
      <b-card no-body class="border">
        <b-tabs card>
          <b-tab title="General">
            <div class="mt-4 d-flex justify-content-between">
              <!-- <LmRadio
                v-model="formData.allowWorkflow"
                name="allow_workflow"
                label="Permitir Firmantes y Revisores"
                isVertical
                :options="[
                  {text: $t('allow'), value: true},
                  {text: $t('not_allow'), value: false}
                ]"
              /> -->
              <LmRadio
                v-model="formData.typeNumerator"
                @input="onNumeratorChange"
                name="numerator"
                :label="$t('numerator_type')"
                isVertical
                :help="$t('numerator_type_help')"
                :options="[
                  {text: $t('generic'), value: 'generic'},
                  {text: $t('specific'), value: 'specific'}
                ]"
              />
              <LmRadio
                v-model="formData.typeComunicable"
                name="comunicable"
                :label="$t('comunicable_type')"
                isVertical
                :help="$t('comunicable_type_help')"
                :options="[
                  {text: $t('comunicable'), value: 'comunicable'},
                  {text: $t('incomunicable'), value: 'incomunicable'}
                ]"
              />
              <LmRadio
                v-model="formData.typeVisibility"
                name="visibility"
                :label="$t('visibility_type')"
                isVertical
                :help="$t('visibility_type_help')"
                :options="[
                  {text: $t('public'), value: 'public'},
                  {text: $t('private'), value: 'private'}
                ]"
              />
              <div>
                <LmRadio
                  v-model="formData.typeComments"
                  name="comments"
                  :label="$t('Permite comentarios')"
                  isVertical
                  :help="$t('comments_type_help')"
                  :options="[
                    {text: $t('Siempre'), value: 'always'},
                    {text: $t('Nunca'), value: 'never'},
                    {text: $t('Mientras no este finalizado'), value: 'in_progress'},
                  ]"
                />
                <LmCheckbox
                  v-if="formData.typeComments === 'in_progress'"
                  labelSingle="Ocultar comentarios al finalizar"
                  v-model="formData.typeHideCommentsOnFinished"
                />
              </div>
            </div>
            <hr>
            <b-row>
              <LmTreeSelect
                class="col-12 col-md-3"
                v-model="formData.typePrefix"
                :v="$v.formData.typePrefix"
                :options="prefixOptionsForNumerator"
                :label="$t('prefix')"
                :placeholder="$t('numerator_prefix')"
                :help="$t('numerator_prefix_help')"
              />
            </b-row>
            <hr>
            <LmDocumentsPrivileges
              v-model="formData.instancePrivileges"
              :published="formData.publish"
            />
            <hr class="w-100"/>
            <b-row>
              <h3 class="col-12">Template de Contenido</h3>
              <!-- <LmTreeSelect
                class="col-6"
                :options="[{id: 'all', name: 'Todos los usuarios'}, {id: 'area', name: 'Usuarios en la misma área del creador'}, {id: 'subarea', name: 'Usuarios en la misma subarea del creador'}]"
                label="Seleccione que usuarios pueden visualizar los templates de contenido de este tipo de documento"
                v-model="formData.templateViewers"
                :v="$v.formData.templateViewers"
                :clearable="false"
              /> -->
              <p class="col-auto">Si no ingresa ninguna condición los templates van a estar visible para todos los usuarios.</p>
              <LmConditionalBuilder
                class="col-auto"
                :maxConditions="1"
                noGroups
                view="documenttypes"
                ref="contenttemplateConditionals"
                v-model="formData.contenttemplateConditionals"
              />
            </b-row>
            <hr class="w-100">
            <!-- FormBuilderUi -->
            <div id="lm-form-builder-ui" class="wrapper-content w-100 px-0 mt-3">
              <div class="row position-relative">
                <div class="col-12 mt-3">
                  <b-form-group :label="$t('view_modes')">
                    <b-form-radio-group buttons button-variant="primary" v-model="modes.selected">
                      <b-form-radio
                        name="viewMode"
                        value="edit"
                        @change="modes.editView = $event === 'edit'"
                      >
                        <font-awesome-icon class="mr-1" icon="wrench" />
                        {{ formData.isEditable ? $t('edit_mode') : $t('view_config') }}
                      </b-form-radio>
                      <b-form-radio
                        name="viewMode"
                        value="preview"
                        @change="modes.editView = $event === 'edit'"
                      >
                        <font-awesome-icon class="mr-1" icon="eye" />
                        {{ $t('preview_mode') }}
                      </b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </div>
                <div class="col-12">
                  <h3>{{ !formData.isEditable ? 'Previsualización del formulario' : 'Formulario de ingreso de datos' }}</h3>
                  <b-row>
                    <LmSuperPowerSelectV2
                      v-if="formData.isEditable"
                      class="col-12 col-md-6"
                      :options="documentTypesOptionsForDuplicate"
                      @input="loadFormElements"
                      :label="$t('import_form_components_from_another_document_type')"
                    />
                  </b-row>
                  <div class="row" v-if="componentsOptions.content.length">
                    <div class="col-12 col-md-6 px-0 formbuilder-component-section border-top border-right" v-show="modes.editView">
                      <LmSvgIcon
                        v-if="form.formElements.length === 0"
                        wrapperClass="d-flex mt-4 justify-content-center align-items-center flex-column"
                        width="18em"
                        icon="LmSettingsIcon"
                        text="Creá el formulario agregando los campos que desees"
                      />
                      <LmForm ref="lmFormBuilderRef" id="documentFormElements">
                        <draggable
                          class="col-12"
                          v-model="form.formElements"
                          @start="drag=true"
                          @end="drag=false"
                          animation="150"
                          handle=".handle"
                          >
                          <div v-for="(formElement, index) in form.formElements" :key="formElement.id" class="mt-4">
                            <header
                              class="d-flex justify-content-between align-items-center bg-primary text-white px-3 handle shadow rounded-lg"
                              :class="{'bg-info': !shouldCreatePortal(form.formElements[index].componentName)}">
                              <font-awesome-icon v-if="formData.isEditable" class="mr-4" icon="arrows-alt" style="width:18px; height:18px;" />
                              <h4 v-b-toggle="`collapse-${index}`" class="flex-grow-1 text-center my-0 py-3 handle">{{title(form.formElements[index])}}</h4>
                              <div v-if="shouldCreatePortal(form.formElements[index].componentName)" class="circle d-flex justify-content-center align-items-center">{{index}}</div>
                              <div class="d-flex align-items-center">
                                <font-awesome-icon v-b-toggle="`collapse-${index}`" class="collapse-formsection-up ml-4 clickable" icon="chevron-up" style="width:16px; height:16px;" />
                                <font-awesome-icon v-b-toggle="`collapse-${index}`" class="collapse-formsection-down ml-4 clickable" icon="chevron-down" style="width:16px; height:16px;" />
                                <font-awesome-icon v-if="formData.isEditable" class="ml-4 clickable" icon="trash" @click="removeFormElement(index)" style="width:16px; height:16px;" />
                              </div>
                            </header>
                            <b-collapse
                              accordion="my-accordion"
                              :id="`collapse-${index}`"
                              visible
                              class="p-4 border border-top-0 rounded-lg bg-white"
                              >
                              <LmSelect
                                :id="'select-elements-' + index"
                                v-model="form.formElements[index].componentName"
                                :options="componentsOptions"
                                :label="$t('select_elemet_type')"
                                @input="selectorElementForm($event, index)"
                              />
                              <component
                                :index="index"
                                :is="whatComponentBuilderUse(form.formElements[index].componentName)"
                                :id="form.formElements[index].formObjectToSendToServerProperty || form.formElements[index].id"
                                :componentData="form.formElements[index]"
                                :optionsChildOf="buildOptionsChildOf(form.formElements[index].formObjectToSendToServerProperty)"
                                :leftValueToCompareOptions="leftValueToCompareOptions(form.formElements[index])"
                                :visibilityDependOnConditions="form.formElements[index].visibilityDependOnConditions"
                                :optionsSameAsValidation="{content: buildSameAsOptions(form.formElements)}"
                                :validationsData="getValidation(form.formElements[index].formObjectToSendToServerProperty)"
                                :options="lmSuperPowerSelectV2BuilderUiOptions"
                                :isOnEditMode="isOnEditMode"
                                @input="inputHandler($event, index)"
                                @validations-changes="validationsChangesHandler"
                                v-bind="$attrs"
                              />
                              <template v-if="lumbreVersion === 2">
                                <hr class="w-100">
                                <b-row>
                                  <LmCheckbox
                                    class="col-12"
                                    labelSingle="Permite edición por usuario"
                                    v-model="formElement.componentProps.isEditableByPickedUser"
                                  />
                                </b-row>
                              </template>
                              <template v-if="extraPropsForPdf(formElement)">
                                <hr class="w-100">
                                <section class="row">
                                  <h4 class="col-12">Propiedades para el PDF</h4>
                                  <LmCheckbox
                                    class="col-12"
                                    labelSingle="Ocultar al generar el PDF"
                                    v-model="formElement.isHiddenOnPdf"
                                  />
                                  <LmCheckbox
                                    v-if="form.formElements[index].componentName !== 'LmUploadFiles'"
                                    class="col-12"
                                    labelSingle="Incluir título del campo en el PDF"
                                    v-model="formElement.hasLabelOnPdf"
                                  />
                                  <LmCheckbox
                                    v-if="form.formElements[index].componentName === 'LmRepeatFields'"
                                    class="col-12"
                                    labelSingle="Incluir divisor entre los grupos"
                                    v-model="formElement.addGroupsDividerOnPdf"
                                  />
                                </section>
                              </template>
                            </b-collapse>
                          </div>
                        </draggable>
                        <div class="col-12">
                          <LmButton
                            v-if="formData.isEditable"
                            id="add-field-button"
                            class="mt-4"
                            type="button"
                            lmButtonRootWrapperClass="d-inline-block"
                            lmButtonWrapperClass="col"
                            @click.native="addFormElement(form.formElements.length)"
                            :value="$t('add_field')"
                          />
                        </div>
                      </LmForm>
                    </div>
                    <!-- Preview del formbuilder que se generará -->
                    <div class="col-12 pt-4 formbuilder-preview-section border-top" :class="{ 'col-md-6': modes.editView }">
                      <LmFormBuilder
                        class="px-0"
                        :getComponents="form"
                        :isOnPreviewMode="modes.editView"
                        @openEditFormElement="openEditFormElement"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- FormBuilderUi -->
          </b-tab>
          <b-tab title="Layout del documento">
            <h5>Encabezado</h5>
            <p class="mb-4">Puedes personalizar el encabezado de los documentos.</p>
            <LmCheckbox
              variant="switch"
              labelSingle="Personalizar Encabezado"
              v-model="formData.customHeader"
            />
            <div v-if="formData.customHeader" class="mb-4">
              <hr />
              <LmCheckbox
                variant="switch"
                v-model="formData.customHeaderOptions.position"
                labelSingle="Encabezado al final"
                uncheckedValue="start"
                checkValue="end"
              />
              <LmCheckbox
                variant="switch"
                v-model="formData.customHeaderOptions.showNumeration"
                labelSingle="Mostrar Numeración"
              />
              <LmCheckbox
                variant="switch"
                v-model="formData.customHeaderOptions.showDate"
                labelSingle="Mostrar Fecha"
              />
              <LmCheckbox
                variant="switch"
                v-model="formData.customHeaderOptions.showLogo"
                labelSingle="Mostrar Logo"
              />
              <LmCheckbox
                variant="switch"
                v-model="formData.customHeaderOptions.showTitle"
                labelSingle="Mostrar Título del Encabezado"
              />
              <LmCheckbox
                variant="switch"
                v-model="formData.customHeaderOptions.showCaption"
                labelSingle="Mostrar Subtítulo del Encabezado"
              />
              <LmCheckbox
                variant="switch"
                v-model="formData.customHeaderOptions.showTypeAlias"
                labelSingle="Mostrar Alias de Tipo de Documento en el Encabezado"
              />
              <LmCheckbox
                variant="switch"
                v-model="formData.customHeaderOptions.showDocumentName"
                labelSingle="Mostrar el Nombre del Documento en el Encabezado"
              />
              <LmCheckbox
                variant="switch"
                v-model="formData.customHeaderOptions.showRecipientsOnPdf"
                labelSingle="Mostrar los Destinatarios en el Encabezado"
              />
            </div>
            <div class="mb-4">
              <hr />
              <h5>Visualización de las Firmas</h5>
              <p class="mb-4">Puedes decidir que información incluir debajo de cada firma.</p>
              <LmCheckbox
                variant="switch"
                v-model="formData.visibleSignatureOptions.showUserName"
                labelSingle="Mostrar Nombre y Apellido"
              />
              <LmCheckbox
                variant="switch"
                v-model="formData.visibleSignatureOptions.showPosition"
                labelSingle="Mostrar el Cargo"
              />
              <LmCheckbox
                variant="switch"
                v-model="formData.visibleSignatureOptions.showArea"
                labelSingle="Mostrar el Área"
              />
            </div>
          </b-tab>
          <b-tab title="Usuarios internos" :disabled="formData.documentsFormat === 'oneperson'">
            <div class="d-flex gap-4">
              <LmRadio
                v-model="formData.allowInternalParticipant"
                name="internal_participants"
                :label="$t('allow_internal')"
                isVertical
                :disabled="!formData.allowWorkflow"
                :options="[
                  {text: $t('allow'), value: true}
                ]"
              />
              <LmRadio
                v-if="formData.allowInternalParticipant && formData.allowWorkflow"
                v-model="formData.typeSignature"
                name="signature"
                :label="$t('signature_type')"
                isVertical
                :help="$t('signature_type_help')"
                :options="[
                  {text: 'Electrónica Avanzada (con OTP)', value: 'electronic'},
                  {text: 'Electrónica Simple (sin OTP)', value: 'electronic_without_otp'},
                  {text: $t('digital'), value: 'digital'}
                ]"
              />
              <div class="d-flex flex-column">
                <label>Validaciones</label>
                <a-checkbox-group
                  v-model="formData.internalSignatureValidations"
                  @change="onInternalSignatureValidationsChange"
                >
                  <a-row>
                    <a-col>
                      <a-checkbox :disabled="disableInternalSignatureValidations" value="geolocation" >
                        Geolocalización
                      </a-checkbox>
                    </a-col>
                    <a-col>
                      <a-checkbox :disabled="disableInternalSignatureValidations" value="holographic_simple" >
                        Hológrafa Simple (Usa la firma holográfica definida en el perfil del usuario)
                      </a-checkbox>
                    </a-col>
                    <a-col>
                      <a-checkbox :disabled="disableInternalSignatureValidations" value="holographic_advanced" >
                        Hológrafa Avanzada (Si se quiere capturar la firma holográfica en cada documento)
                      </a-checkbox>
                    </a-col>
                  </a-row>
                </a-checkbox-group>
                <LmRadio
                  v-if="enableInternalHolographicAdvanced && formData.documentsFormat === 'workflow'"
                  v-model="formData.internalSignatureValidationsCapture"
                  class="mt-2 mr-4"
                  name="signature_capture"
                  label="Captura la firma:"
                  isVertical
                  :help="$t('signature_type_help')"
                  :options="[
                    {text: 'Sin tableta', value: 'holographic_simple_capture'},
                    {text: 'Con tableta Wacom', value: 'holographic_wacom_capture'}
                  ]"
                />
              </div>
            </div>
          </b-tab>
          <b-tab title="Usuarios externos" :disabled="formData.documentsFormat === 'oneperson'">
            <div class="mt-4 d-flex" style="gap: 2em">
              <LmRadio
                v-model="formData.typeAllowExternalRecipients"
                name="external_recipients"
                :label="$t('allow_external_recipients')"
                isVertical
                :help="$t('allow_external_recipients_type_help')"
                :options="[
                  {text: $t('allow'), value: true},
                  {text: $t('not_allow'), value: false}
                ]"
              />
              <LmRadio
                v-model="formData.typeAllowExternalParticipants"
                name="external_participants"
                :label="$t('allow_external_participants')"
                isVertical
                :disabled="!formData.allowWorkflow"
                :help="$t('allow_external_participants_type_help')"
                :options="[
                  {text: $t('allow'), value: true},
                  {text: $t('not_allow'), value: false}
                ]"
              />
              <template v-if="formData.typeAllowExternalParticipants">
                <LmRadio
                  v-model="formData.signatureTypeForExternal"
                  name="reviewers"
                  label="Tipo de Firma"
                  isVertical
                  :options="[
                    {text: 'Electrónica con OTP y Biometría', value: 'electronic'},
                    {text: 'Electrónica sin OTP y sin Biometría', value: 'electronic_without_otp'}
                  ]"
                />
              </template>
            </div>
          </b-tab>
          <b-tab title="Usuarios presenciales" v-if="enableInPersonParticipants" :disabled="formData.documentsFormat === 'oneperson'">
            <div class="mt-4 d-flex" style="gap: 2em">
              <LmRadio
                v-model="formData.allowInPersonParticipant"
                name="in_person"
                :label="$t('allow_in_person')"
                isVertical
                :disabled="!formData.allowWorkflow"
                :options="[
                  {text: $t('allow'), value: true},
                  {text: $t('not_allow'), value: false}
                ]"
              />
              <template v-if="formData.allowInPersonParticipant">
                <LmRadio
                  v-model="formData.inPersonSignatureType"
                  name="signature_type"
                  label="Tipo de Firma"
                  isVertical
                  :disabled="!formData.allowWorkflow"
                  :options="[
                    {text: 'Electrónica', value: 'electronic'},
                  ]"
                />
                <div class="d-flex flex-column">
                  <label>Validaciones</label>
                  <a-checkbox-group
                    v-model="formData.inPersonSignatureValidations"
                    @change="onInpersonSignatureValidationsChange"
                  >
                    <a-row>
                      <a-col>
                        <a-checkbox value="otp" disabled>
                          OTP
                        </a-checkbox>
                      </a-col>
                      <a-col>
                        <a-checkbox value="biometric" disabled>
                          Biometría
                        </a-checkbox>
                      </a-col>
                      <a-col>
                        <a-checkbox value="geolocation">
                          Geolocalización
                        </a-checkbox>
                      </a-col>
                      <a-col>
                        <a-checkbox value="holographic">
                          Hológrafa
                        </a-checkbox>
                      </a-col>
                      <a-col>
                        <a-checkbox value="holographic_wacom">
                          Hológrafa con Tableta Wacom
                        </a-checkbox>
                      </a-col>
                    </a-row>
                  </a-checkbox-group>
                </div>
                <LmTreeSelect
                  label="Perfiles habilitados para interacturar con usuarios presenciales"
                  class="cl-12"
                  multiple
                  pathToGetOptions="/customer/profilegroups"
                  v-model="formData.inPersonSpecialProfileGroups"
                  placeholder="Seleccionar perfiles"
                />
              </template>
            </div>
          </b-tab>
          <b-tab title="Avanzado" :disabled="formData.documentsFormat === 'oneperson'">
            <div class="mt-4 d-flex" style="gap: 2em">
              <LmRadio
                v-model="formData.typeAllowReviewers"
                name="reviewers"
                :label="$t('allow_reviewers')"
                isVertical
                :disabled="!formData.allowWorkflow"
                :help="$t('allow_reviewers_type_help')"
                :options="[
                  {text: $t('allow'), value: true},
                  {text: $t('not_allow'), value: false}
                ]"
              />
            </div>
          </b-tab>
          <b-tab v-if="enableDocumentWorkflowFeature" :disabled="formData.documentsFormat === 'oneperson'" title="Workflow">
            <draggable
              class="col-12 worflow-sections"
              v-model="formData.workflowSections"
              @start="drag=true"
              @end="drag=false"
              animation="150"
              handle=".handle"
              >
              <div v-for="(workflowSection, index) in formData.workflowSections" :key="workflowSection.id" class="mt-4">
                <header
                  class="d-flex justify-content-between align-items-center bg-secondary text-white px-3 handle shadow rounded-lg">
                  <font-awesome-icon v-if="formData.isEditable" class="mr-4" icon="arrows-alt" style="width:18px; height:18px;" />
                  <h4 v-b-toggle="`collapse-worlflowsection-${index}`" class="flex-grow-1 text-center my-0 py-3 handle">{{formData.workflowSections[index].title}}</h4>
                  <div class="circle d-flex justify-content-center align-items-center">{{index}}</div>
                  <div class="d-flex align-items-center">
                    <font-awesome-icon v-b-toggle="`collapse-worlflowsection-${index}`" class="collapse-worlflowsection-up ml-4 clickable" icon="chevron-up" style="width:16px; height:16px;" />
                    <font-awesome-icon v-b-toggle="`collapse-worlflowsection-${index}`" class="collapse-worlflowsection-down ml-4 clickable" icon="chevron-down" style="width:16px; height:16px;" />
                    <font-awesome-icon v-if="formData.isEditable" class="ml-4 clickable" icon="trash" @click="removeWorkflowSection(index)" style="width:16px; height:16px;" />
                  </div>
                </header>
                <b-collapse
                  accordion="workflow-accordion"
                  :id="`collapse-worlflowsection-${index}`"
                  visible
                  class="p-4 border border-top-0 rounded-lg bg-white"
                  >
                  <LmSelect
                    :id="'select-elements-' + index"
                    v-model="formData.workflowSections[index].type"
                    :options="workflowComponentsOptions"
                    :label="$t('select_elemet_type')"
                    @input="changeWorkflowSectionType($event, index)"
                  />
                  <LmCheckbox
                    v-if="workflowSectionIsDynamic(formData.workflowSections[index])"
                    variant="switch"
                    :labelSingle="$t('allow_reviewers_groups')"
                    v-model="formData.workflowSections[index].showReviewersGroups"
                  />
                  <LmParticipants
                    v-if="workflowSectionIsFixed(formData.workflowSections[index])"
                    label=""
                    :subtitle="$t('lm_workflow_subtitle')"
                    v-model="formData.workflowSections[index].participants"
                    :showReviewersGroups="true"
                  />
                </b-collapse>
              </div>
            </draggable>
            <div class="col-12">
              <LmButton
                v-if="formData.isEditable"
                id="add-field-button"
                class="mt-4"
                type="button"
                lmButtonRootWrapperClass="d-inline-block"
                lmButtonWrapperClass="col"
                @click.native="addWorkflowSection()"
                :value="$t('add')"
              />
            </div>
          </b-tab>
          <b-tab v-if="enableDocumentIntegrations" title="Integraciones">
            <b-row class="p-4">
              <b-col class="col-6">
              <LmRadio
                v-model="formData.integrationAvailable"
                name="tad"
                :label="$t('integration_available')"
                isVertical
                :help="$t('integration_available_help')"
                :options="[
                  {text: 'Si', value: true},
                  {text: 'No', value: false}
                ]"
              />
              </b-col>
              <b-col v-if="formData.integrationAvailable" class="col-12">
                <hr>
                <b-row>
                  <b-col class="col-10">
                    <h4>Código de ejemplo</h4>
                  </b-col>
                  <b-col class="col-2">
                    <lm-button-v2 class="float-right" shape="circle" icon="reload" @click="reloadDocumentationSamples()"/>
                  </b-col>
                </b-row>
                <b-card no-body class="border">
                  <b-tabs card>
                    <b-tab
                      v-for="(item, index) in apiIntegrationCodeSample" :key="index" class="mt-4"
                      :title="item.tabname"
                      :active="index === 0"
                    >
                      <b-row>
                        <b-col class="col-12">
                          <span v-html="item.intro"></span>
                          <p>
                            Estas integraciones requiere una autenticacion <strong>Oauth2</strong>, la cual también se incluye en el ejemplo.
                          </p>
                          <LmCodeInput
                            class="integration-code-sample"
                            v-model="item.code"
                            maxHeight="600px"
                          />
                        </b-col>
                      </b-row>
                    </b-tab>
                  </b-tabs>
                </b-card>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-card>
    </LmForm>
    <div class="d-flex wrapper-content pl-0">
      <LmButton
        class="col-auto pl-0"
        type="cancel"
        :value="$t('cancel')"
        buttonClass="btn-secondary"
        @click="onCancel()"
      />
      <LmButton
        v-if="!formData.publish && formData.isEditable"
        class="col-auto"
        type="button"
        :value="$t('save')"
        buttonClass="btn-primary"
        @click="onSubmit()"
      />
      <LmButton
        v-if="isOnEditMode && !formData.publish"
        class="col-auto"
        type="button"
        :value="formData.isEditable? $t('save_and_publish') : $t('publish')"
        buttonClass="btn-info"
        :requireConfirmation="true"
        :confirmationTitle="$t('publish_confirmation_title')"
        :confirmationMessage="$t('publish_confirmation_message')"
        @click="onPublish()"
      />
      <LmButton
        v-if="isOnEditMode && formData.publish"
        class="col-auto"
        type="button"
        value="Despublicar"
        buttonClass="btn-warning"
        :requireConfirmation="true"
        :confirmationTitle="$t('defuse_confirmation_title')"
        :confirmationMessage="$t('defuse_confirmation_message')"
        @click="onUnpublish()"
      />
      <LmButton
        v-if="isOnEditMode"
        class="col-auto"
        type="button"
        value="Duplicar"
        buttonClass="btn-info"
        requireConfirmation
        confirmationTitle="¿Estas seguro?"
        confirmationMessage="Vas a duplicar el tipo de documento completamente."
        @click="onClone()"
      />
      <LmButton
        v-if="isOnEditMode && formData.publish"
        class="col-auto"
        type="button"
        value="Actualizar"
        buttonClass="btn-success"
        requireConfirmation
        confirmationTitle="¿Estas seguro?"
        confirmationMessage="El proceso de Actualizacion crea un nuevo tipo de documento y despublica el anterior."
        @click="onEdit()"
      />
      <LmButton
        v-if="isOnEditMode"
        class="col-auto"
        type="button"
        :value="$t('delete')"
        buttonClass="btn-danger"
        action="delete"
        @click="onDelete()"
      />
    </div>
  </div>
</template>

<script>
import {
  required,
  maxLength
} from 'vuelidate/lib/validators'

import LmForm from '@/components/form/LmForm'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmButton from '@/components/form/elements/LmButton'
import LmRadio from '@/components/form/elements/LmRadio'
import LmSelect from '@/components/form/elements/LmSelect'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import draggable from 'vuedraggable'
import VueScrollTo from 'vue-scrollto'
import LmFormBuilder from '@/components/LmFormBuilder'
import LmDocumentsPrivileges from '@/components/LmDocumentsPrivileges'

import LmTextNumberEditorTextAreaPasswordBuilderUi from '@/components/lmFormBuilderUi/LmTextNumberEditorTextAreaPasswordBuilderUi'
import LmEmailInputBuilderUi from '@/components/lmFormBuilderUi/LmEmailInputBuilderUi'
import LmFormSubtitlesBuilderUi from '@/components/lmFormBuilderUi/LmFormSubtitlesBuilderUi'
import LmFormEmptySpaceBuilderUi from '@/components/lmFormBuilderUi/LmFormEmptySpaceBuilderUi'
import LmFormSeparatorBuilderUi from '@/components/lmFormBuilderUi/LmFormSeparatorBuilderUi'
import LmSelectBuilderUi from '@/components/lmFormBuilderUi/LmSelectBuilderUi'
import LmSuperPowerSelectV2BuilderUi from '@/components/lmFormBuilderUi/LmSuperPowerSelectV2BuilderUi'
import LmButtonBuilderUi from '@/components/lmFormBuilderUi/LmButtonBuilderUi'
import LmDateBuilderUi from '@/components/lmFormBuilderUi/LmDateBuilderUi'
import LmDateTimeBuilderUi from '@/components/lmFormBuilderUi/LmDateTimeBuilderUi'
import LmLeaFletMapBuilderUi from '@/components/lmFormBuilderUi/LmLeaFletMapBuilderUi'
import LmHtmlContentBuilderUi from '@/components/lmFormBuilderUi/LmHtmlContentBuilderUi'
import LmFormPortalBuilderUi from '@/components/lmFormBuilderUi/LmFormPortalBuilderUi'
import LmColorPickerBuilderUi from '@/components/lmFormBuilderUi/LmColorPickerBuilderUi'
import LmCommentBuilderUi from '@/components/lmFormBuilderUi/LmCommentBuilderUi'
import LmRepeatFieldsBuilderUi from '@/components/lmFormBuilderUi/LmRepeatFieldsBuilderUi'
import LmCheckboxBuilderUi from '@/components/lmFormBuilderUi/LmCheckboxBuilderUi'
import LmUploadFilesBuilderUi from '@/components/lmFormBuilderUi/LmUploadFilesBuilderUi'
import LmUploadImageBuilderUi from '@/components/lmFormBuilderUi/LmUploadImageBuilderUi'
import LmSignersBuilderUi from '@/components/lmFormBuilderUi/LmSignersBuilderUi'
import LmImportFromExcelBuilderUi from '@/components/lmFormBuilderUi/LmImportFromExcelBuilderUi'
import LmCustomBuilderUi from '@/components/lmFormBuilderUi/LmCustomBuilderUi'
import LmRadioBuilderUi from '@/components/lmFormBuilderUi/LmRadioBuilderUi'
import LmCodeInputBuilderUi from '@/components/lmFormBuilderUi/LmCodeInputBuilderUi'
import LmPageBreakBuilderUi from '@/components/lmFormBuilderUi/LmPageBreakBuilderUi'
import LmTreeSelectBuilderUi from '@/components/lmFormBuilderUi/LmTreeSelectBuilderUi'
import LmEditorBuilderUi from '@/components/lmFormBuilderUi/LmEditorBuilderUi'
import LmTagsInputBuilderUi from '@/components/lmFormBuilderUi/LmTagsInputBuilderUi'
import LmReaderInputBuilderUi from '@/components/lmFormBuilderUi/LmReaderInputBuilderUi'
import LmButtonV2 from '@/components/form/elements/LmButtonV2'
import LmCodeInput from '@/components/form/elements/LmCodeInput'
import LmDatePickerBuilderUi from '@/components/lmFormBuilderUi/LmDatePickerBuilderUi'

import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'
import lmFormBuilderUi from '@/mixins/lmFormBuilderUi.js'
import lmWorkflowBuilderUi from '@/mixins/lmWorkflowBuilderUi.js'

import LmConditionalBuilder from '@/components/lmConditionalBuilder'

export default {
  provide () {
    const context = {}
    for (const key in this.form) {
      Object.defineProperty(context, key, {
        enumerable: true,
        get: () => this.form[key]
      })
    }
    return { context }
  },
  components: {
    LmForm,
    LmSuperPowerSelectV2,
    LmTreeSelect,
    LmTextInput,
    LmTextArea,
    LmCheckbox,
    LmButton,
    LmSelect,
    LmRadio,
    LmTextNumberEditorTextAreaPasswordBuilderUi,
    LmEmailInputBuilderUi,
    LmFormSubtitlesBuilderUi,
    LmFormEmptySpaceBuilderUi,
    LmFormSeparatorBuilderUi,
    LmSelectBuilderUi,
    LmSuperPowerSelectV2BuilderUi,
    LmButtonBuilderUi,
    LmDateBuilderUi,
    LmDateTimeBuilderUi,
    LmLeaFletMapBuilderUi,
    LmHtmlContentBuilderUi,
    LmFormPortalBuilderUi,
    LmColorPickerBuilderUi,
    draggable,
    LmCommentBuilderUi,
    LmRepeatFieldsBuilderUi,
    LmCheckboxBuilderUi,
    LmUploadFilesBuilderUi,
    LmUploadImageBuilderUi,
    LmFormBuilder,
    LmSignersBuilderUi,
    LmImportFromExcelBuilderUi,
    LmCustomBuilderUi,
    LmRadioBuilderUi,
    LmCodeInputBuilderUi,
    LmTreeSelectBuilderUi,
    LmEditorBuilderUi,
    LmTagsInputBuilderUi,
    LmConditionalBuilder,
    LmDocumentsPrivileges,
    LmReaderInputBuilderUi,
    LmCodeInput,
    LmButtonV2,
    LmDatePickerBuilderUi,
    LmPageBreakBuilderUi
  },
  mixins: [lmToasts, lmFormBuilderUi, lmWorkflowBuilderUi],
  data () {
    return {
      lumbreVersion: Number(process.env?.VUE_APP_DOCUMENTS_VERSION) || 1,
      apiIntegrationCodeSample: '',
      formData: {
        typeName: '',
        typeAlias: '',
        typeDescription: '',
        typeNumerator: 'generic',
        typeComunicable: 'comunicable',
        typeVisibility: 'public',
        typeSignature: 'electronic',
        typeComments: 'always',
        signatureValidations: ['holographic'],
        signatureTypeForExternal: 'electronic',
        inPersonSignatureType: 'electronic',
        inPersonSignatureValidations: ['holographic'],
        inPersonSpecialProfileGroups: [],
        internalSignatureValidations: [],
        internalSignatureValidationsCapture: 'holographic_simple_capture',
        typeAllowReviewers: true,
        typeAllowExternalParticipants: true,
        typeAllowExternalRecipients: true,
        typeHideCommentsOnFinished: false,
        allowInternalParticipant: true,
        allowInPersonParticipant: false,
        allowWorkflow: true,
        typePrefix: null,
        customHeader: false,
        documentsFormat: 'workflow',
        customHeaderOptions: {
          position: 'start',
          showNumeration: true,
          showDate: true,
          showLogo: true,
          showTitle: true,
          showCaption: true,
          showTypeAlias: true,
          showDocumentName: true,
          showRecipientsOnPdf: false
        },
        visibleSignatureOptions: {
          showUserName: true,
          showPosition: true,
          showArea: true
        },
        publish: false,
        integrationAvailable: false,
        isEditable: true,
        instancePrivileges: {
          area: [],
          subarea: [],
          role: []
        },
        templateViewers: { id: 'all', name: 'Todos los usuarios' },
        contenttemplateConditionals: null,
        workflowSections: []
      },
      form: {
        validations: {},
        formElements: [],
        lumbreInternal: true
      },
      initialForm: {},
      modes: {
        selected: 'edit',
        editView: true
      },
      visibilityDependOnIsChildCheckbox: false,
      isLoading: false,
      documentTypesOptionsForDuplicate: [],
      prefixOptions: null,
      enableDocumentIntegrations: process.env?.VUE_APP_ENABLE_DOCUMENTSTYPE_INTEGRATIONS === 'yes'
    }
  },
  validations: {
    formData: {
      typeName: {
        required
      },
      typeAlias: {
        required
      },
      typeDescription: {
        // required
      },
      typePrefix: {
        required,
        name: {
          maxLength: maxLength(5)
        }
      }
    }
  },
  props: {
    pathToRedirectOnCancel: {
      type: String,
      default: '/listbuilder/view/6116c1efadd400578cd0e9e8'
    }
  },
  computed: {
    prefixOptionsForNumerator () {
      if (this.prefixOptions) {
        return this.prefixOptions.filter(el => el.numeratorType === this.formData.typeNumerator)
      }
      return null
    },
    disableInternalSignatureValidations () {
      return process.env?.VUE_APP_ENABLE_INTERNAL_SIGNATURE_VALIDATIONS !== 'yes'
    },
    enableInPersonParticipants () {
      return process.env?.VUE_APP_ENABLE_IN_PERSON_PARTICIPANTS === 'yes'
    },
    enableInternalHolographicAdvanced () {
      return this.formData.internalSignatureValidations.find((el) => el === 'holographic_advanced')
    }
  },
  methods: {
    onInternalSignatureValidationsChange (event) {
      if (event.at(-1) === 'holographic_simple') {
        this.formData.internalSignatureValidations = this.formData.internalSignatureValidations.filter((el) => el !== 'holographic_advanced')
      }

      if (event.at(-1) === 'holographic_advanced') {
        this.formData.internalSignatureValidations = this.formData.internalSignatureValidations.filter((el) => el !== 'holographic_simple')
      }
    },
    onInpersonSignatureValidationsChange (event) {
      if (event.at(-1) === 'holographic_wacom') {
        this.formData.inPersonSignatureValidations = this.formData.inPersonSignatureValidations.filter((el) => el !== 'holographic')
      }

      if (event.at(-1) === 'holographic') {
        this.formData.inPersonSignatureValidations = this.formData.inPersonSignatureValidations.filter((el) => el !== 'holographic_wacom')
      }
    },
    async onNumeratorChange (event) {
      try {
        const prefixOptions = await commonsApi.axiosGetWrapper(`/customer/prefixes/${event}`)
        this.prefixOptions = prefixOptions.data.items.map(el => {
          return {
            id: el.id,
            name: el.prefix,
            numeratorType: el.numeratorType
          }
        })
        if (!this.prefixOptions.some(el => el.id === this.formData.typePrefix?.id)) {
          this.formData.typePrefix = null
        }
      } catch (error) {
        console.log(error)
      }
    },
    async onSubmit () {
      const documenttypeData = {
        ...this.formData,
        documentFields: [...this.form.formElements],
        documentFieldsValidations: this.form.validations,
        contenttemplateConditionals: this.$refs.contenttemplateConditionals.conditionals
      }
      try {
        await this.validationForm(this.$v, false, this.formData)
        this.isLoading = true
        if (this.isOnEditMode) {
          const r = await commonsApi.axiosPutWrapper(`/documenttypes/${this.$route.params.id}`, documenttypeData)
          this.lmToastSuccessMessage(`Se editó ${r?.data?.typeName || ' el tipo de documento'} correctamente.`, 'Se guardó exitosamente')
        } else {
          const r = await commonsApi.axiosPostWrapper(`/documenttypes/`, documenttypeData)
          this.lmToastSuccessMessage(`Se creó ${r?.data?.typeName || ' el tipo de documento'} correctamente.`, 'Se guardó exitosamente')
        }
        setTimeout(() => {
          this.isLoading = false
          this.$router.push(this.pathToRedirectOnCancel)
        }, 650)
      } catch (error) {
        if (error?.response?.data?.message) {
          this.lmModalDangerMessage({
            btnText: this.$t('try_again'),
            resultSubtitle: this.$t('talk_to_admin'),
            message: error?.response?.data?.message
          })
        } else {
          this.showToastFormError(error.message || null)
        }
      } finally {
        this.isLoading = false
      }
    },
    async onClone () {
      try {
        this.isLoading = true
        await this.validationForm(this.$v, false, this.formData)
        const r = await commonsApi.axiosPostWrapper(`/documenttypes/clone-entity`, { id: this.$route.params.id })
        this.lmToastSuccessMessage(`Se duplicó ${r?.data?.typeName || ' el tipo de documento'} correctamente.`, 'Se guardó exitosamente')
        setTimeout(() => {
          this.isLoading = false
          this.$router.push(this.pathToRedirectOnCancel)
        }, 650)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onEdit () {
      try {
        this.isLoading = true
        const documenttypeData = {
          id: this.$route.params.id,
          ...this.formData,
          documentFields: [...this.form.formElements],
          documentFieldsValidations: this.form.validations,
          contenttemplateConditionals: this.$refs.contenttemplateConditionals.conditionals
        }
        await this.validationForm(this.$v, false, this.formData)
        const r = await commonsApi.axiosPostWrapper(`/documenttypes/edit-entity`, documenttypeData)
        this.lmToastSuccessMessage(`Se editó ${r?.data?.typeName || ' el tipo de documento'} correctamente.`, 'Se guardó exitosamente')
        setTimeout(() => {
          this.isLoading = false
          this.$router.push(this.pathToRedirectOnCancel)
        }, 650)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onPublish () {
      try {
        // Al publicar debo poder modificar nombre y descripción
        const documentTypeData = {
          ...this.formData,
          documentFields: [...this.form.formElements],
          documentFieldsValidations: this.form.validations
        }
        const r = await commonsApi.axiosPutWrapper(`/documenttypes/publish/${this.$route.params.id}`, documentTypeData)
        this.lmToastSuccessMessage(`Se publicó ${r?.data?.typeName || ' el tipo de documento'} correctamente.`, 'Se guardó exitosamente')
        setTimeout(() => {
          this.$router.push(this.pathToRedirectOnCancel)
        }, 650)
      } catch (error) {
        console.log(error)
      }
    },
    async onDelete () {
      try {
        this.isLoading = true
        if (this.isOnEditMode) {
          const r = await commonsApi.axiosPutWrapper(`/documenttypes/delete/${this.$route.params.id}`)
          this.lmToastSuccessMessage(`Se eliminó ${r?.data?.typeName || ' el tipo de documento'} correctamente.`, 'Se eliminó exitosamente')
          setTimeout(() => {
            this.$router.push(this.pathToRedirectOnCancel)
          }, 650)
        }
      } catch (error) {
        this.lmToastDangerMessage('Lo sentimos, no se pudo eliminar el Tipo de Documento.', 'Error')
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onUnpublish () {
      try {
        this.isLoading = true
        if (this.isOnEditMode) {
          const r = await commonsApi.axiosPutWrapper(`/documenttypes/unpublish/${this.$route.params.id}`)
          this.lmToastSuccessMessage(`Se desactivó ${r?.data?.typeName || ' el tipo de documento'} correctamente.`, 'Se desactivó exitosamente')
          setTimeout(() => {
            this.$router.push(this.pathToRedirectOnCancel)
          }, 650)
        }
      } catch (error) {
        this.lmToastDangerMessage('Lo sentimos, no se pudo desactivar el Tipo de Documento.', 'Error')
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    onCancel () {
      this.$router.push(this.pathToRedirectOnCancel)
    },
    extraPropsForPdf (element) {
      const excludedElements = [
        'LmFormSeparator',
        'LmFormEmptySpace',
        'LmFormSubtitles',
        'LmImportFromExcel'
      ]
      return !excludedElements.includes(element.componentName)
    },
    leftValueToCompareOptions (formElementToExclude) {
      return {
        disabledOption: this.$t('Element'),
        content: this.form.formElements.filter(e => e.hasOwnProperty('formObjectToSendToServerProperty')).filter(e => e.id !== formElementToExclude.id).map(e => ({ value: e.formObjectToSendToServerProperty, text: e.componentProps.label }))
      }
    },
    shouldCreatePortal (componentName) {
      return componentName !== 'LmComment'
    },
    openEditFormElement (index) {
      this.$root.$emit('bv::toggle::collapse', `collapse-${index}`)
    },
    title (component) {
      if (this.componentsOptions?.content?.length) {
        const componentLabel = component?.componentProps?.label
        const componentValue = component?.componentProps?.value
        const componentText = component?.componentProps?.text
        const { text } = this.componentsOptions.content.find(e => e.value === component?.componentName)
        let moreInfo = ''
        if (componentLabel) {
          moreInfo += ' - ' + componentLabel
        } else if (componentValue) {
          moreInfo += ' - ' + componentValue
        } else if (componentText) {
          moreInfo += ' - ' + componentText
        }
        return text + moreInfo
      } else {
        return ''
      }
    },
    addFormElement (elementIndex) {
      this.selectorElementForm('LmTextInput', elementIndex)
    },
    inputHandler (event, index) {
      this.form.formElements[index] = event
    },
    validationsChangesHandler (payload) {
      let newValidation = {}
      const formValidationHasItem = Object.keys(this.form.validations).length
      if (formValidationHasItem) {
        for (const validation in this.form.validations) {
          const existFormObjectToSendToServerPropertyForValidation = this.form.formElements.find((el) => el.formObjectToSendToServerProperty === validation)
          if (existFormObjectToSendToServerPropertyForValidation) {
            newValidation = { ...newValidation, [validation]: this.form.validations[validation] }
          }
        }
        this.form.validations = { ...newValidation, ...payload }
      } else {
        this.form.validations = { ...this.form.validations, ...payload }
      }
    },
    showToastFormError (msg = this.$t('form_with_errors')) {
      this.lmModalDangerMessage({ message: msg })
    },
    errorScrollTo () {
      VueScrollTo.scrollTo(this.id, 1000, { offset: -60 })
    },
    validationForm (validation, mustShowToast = true, formData) {
      if (!formData.typeName) {
        return Promise.reject(new Error('El campo Nombre es obligatorio'))
      }
      if (!formData.typeAlias) {
        return Promise.reject(new Error('El campo Alias es obligatorio'))
      }
      // if (!formData.typeDescription) {
      //   return Promise.reject(new Error('El campo Descripción es obligatorio'))
      // }
      if (!formData.typePrefix) {
        return Promise.reject(new Error('El campo Prefijo es obligatorio'))
      }
      validation.$touch()
      if (validation.$error) {
        if (mustShowToast) {
          this.showToastFormError()
        }
        this.errorScrollTo()
        return Promise.reject(new Error('Todos los campos son obligatorios'))
      } else {
        if (!validation.$pending || !validation.$error) {
          return Promise.resolve(true)
        } else {
          Promise.reject(new Error('Todos los campos son obligatorios'))
        }
      }
    },
    async loadFormElements (event) {
      try {
        if (Array.isArray(event) && !event.length) {
          this.form.formElements = []
        } else {
          const documenttype = await commonsApi.axiosGetWrapper(`documenttypes/${event.id}`)
          const fields = documenttype.data.documentFields
          this.form.formElements = fields
        }
      } catch (error) {
        console.log(error)
      }
    },
    async reloadDocumentationSamples () {
      const apiIntegrationCodeSampleReq = await commonsApi.axiosGetWrapper(`/documenttypes/documentation-sample/${this.$route?.params?.id}`)
      this.apiIntegrationCodeSample = apiIntegrationCodeSampleReq.data
    }
  },
  watch: {
    'formData.allowWorkflow' (val) {
      if (!val) {
        this.formData.typeAllowExternalParticipants = false
        this.formData.typeAllowReviewers = false
        this.formData.allowInPersonParticipant = false
      } else {
        this.formData.allowInternalParticipant = true
      }
    }
  },
  async created () {
    try {
      this.isLoading = true
      this.initialForm = JSON.stringify(this.form)

      if (this.isOnEditMode) {
        const { data } = await commonsApi.axiosGetWrapper(`documenttypes/${this.$route.params.id}`)
        // Cargo las propiedades en modo edición
        for (const key in this.formData) {
          if (data.hasOwnProperty(key)) {
            this.formData[key] = data[key]
          }
        }
        this.form.formElements = data?.documentFields || []
        this.form.validations = data?.documentFieldsValidations || {}

        if (this.formData.isEditable === false) {
          this.modes.selected = 'preview'
          this.modes.editView = false
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  },
  async mounted () {
    // Opciones para duplicar tipos de documento
    const documentTypes = await commonsApi.axiosGetWrapper('/documenttypes/?pageSize=100')
    const options = documentTypes.data.rows.filter(doc => doc._id !== this.$route?.params?.id).map(doc => {
      return {
        id: doc._id,
        name: doc.typeName
      }
    })
    this.documentTypesOptionsForDuplicate = options

    const apiIntegrationCodeSampleReq = await commonsApi.axiosGetWrapper(`/documenttypes/documentation-sample/${this.$route?.params?.id}`)
    this.apiIntegrationCodeSample = apiIntegrationCodeSampleReq.data

    const prefixOptions = await commonsApi.axiosGetWrapper(`/customer/prefixes/${this.formData.typeNumerator}`)
    this.prefixOptions = prefixOptions.data.items.map(el => {
      return {
        id: el.id,
        name: el.prefix,
        numeratorType: el.numeratorType
      }
    })
  }
}
</script>

<style lang="sass" scoped>
.circle
  background: white
  color: black
  border-radius: 50%
  width: 25px
  height: 25px
  text-align: center

.collapse-worlflowsection-up.collapsed
  display: inherit
.collapse-worlflowsection-up.not-collapsed
  display: none

.collapse-worlflowsection-down.not-collapsed
  display: inherit
.collapse-worlflowsection-down.collapsed
  display: none

.collapse-formsection-up.collapsed
  display: inherit
.collapse-formsection-up.not-collapsed
  display: none

.collapse-formsection-down.not-collapsed
  display: inherit
.collapse-formsection-down.collapsed
  display: none
.formbuilder-component-section, .formbuilder-preview-section
  overflow: auto
  max-height: 800px
</style>
